var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.258,
    height: 28.257,
    viewBox: "0 0 28.258 28.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 14.129,
    cy: 14.129,
    rx: 14.129,
    ry: 14.129,
    transform: "translate(0 0)",
    fill: "#55acee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139978",
    "data-name": "Group 139978",
    transform: "translate(6.387 8.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34243",
    "data-name": "Path 34243",
    d: "M41.753,35.63a6.815,6.815,0,0,1-1.962.537,3.425,3.425,0,0,0,1.5-1.89,6.838,6.838,0,0,1-2.169.829A3.419,3.419,0,0,0,33.3,38.223a9.7,9.7,0,0,1-7.041-3.57,3.42,3.42,0,0,0,1.057,4.561,3.392,3.392,0,0,1-1.547-.428c0,.015,0,.029,0,.043a3.418,3.418,0,0,0,2.74,3.349,3.429,3.429,0,0,1-1.543.059A3.42,3.42,0,0,0,30.16,44.61,6.9,6.9,0,0,1,25.1,46.024,9.715,9.715,0,0,0,40.058,37.84c0-.148,0-.3-.01-.442a6.927,6.927,0,0,0,1.7-1.768Z",
    transform: "translate(-25.103 -34.028)",
    fill: "#f1f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bbff714f1dcfdfd6af3ef32264bb493b.svg";
export { ForwardRef as ReactComponent };